import { CardBody, Collapse } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { AddFriend, Href } from "../../../../../Constant";
import { FOLLOWER_DATA } from "../../../../../Data/SocialApp";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { MyProfileClassCollapseProp } from "../../../../../Type/SocialAppType";

const FollowerCardCollapse = ({ isFilter }: MyProfileClassCollapseProp) => {
  return (
    <Collapse isOpen={isFilter}>
      <CardBody className="social-list filter-cards-view">
        {FOLLOWER_DATA.map((data, index) => (
          <div className="d-flex" key={index}>
            <Image className="img-50 img-fluid m-r-20 rounded-circle" alt="img" src={dynamicImage(`user/${data.imageName}`)}/>
            <div className="flex-grow-1">
              <span className="d-block">{data.name}</span>
              <a href={Href}>{AddFriend}</a>
            </div>
          </div>
        ))}
      </CardBody>
    </Collapse>
  );
};

export default FollowerCardCollapse;
